import { request as __request } from '../core/request.js';
export class WebhooksService {
    /**
     * List all webhooks
     * @returns Webhook Existing webhooks fetched successfully
     */
    listAllWebhooks() {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/webhooks',
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Create a webhook
     * @param requestBody
     * @returns Webhook A webhook created successfully
     */
    createWebhook(requestBody) {
        return __request(this.client, this.config, {
            method: 'POST',
            url: '/webhooks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized. The API Key is invalid or disabled.`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Get a webhook
     * @param id The webhooks's unique identifier
     * @returns Webhook Existing webhook fetched successfully
     */
    getWebhook(id) {
        return __request(this.client, this.config, {
            method: 'GET',
            url: '/webhooks/{id}',
            path: {
                id: id,
            },
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                404: `The webhook does not exist`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Update a webhook
     * @param id The webhooks's unique identifier
     * @param requestBody
     * @returns Webhook Existing webhook updated successfully
     */
    updateWebhook(id, requestBody) {
        return __request(this.client, this.config, {
            method: 'PUT',
            url: '/webhooks/{id}',
            path: {
                id: id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized. The API Key is invalid or disabled.`,
                404: `The webhook does not exist`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Delete a webhook
     * @param id The webhooks's unique identifier
     * @returns any Existing webhook deleted successfully
     */
    deleteWebhook(id) {
        return __request(this.client, this.config, {
            method: 'DELETE',
            url: '/webhooks/{id}',
            path: {
                id: id,
            },
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                404: `The webhook does not exist`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Rotate a webhook secret
     * The existing secret will be invalidated immediately and subsequent webhook payloads will be
     * accompanied by HMACs using the new secret.
     *
     * @param id The webhooks's unique identifier
     * @returns Webhook The secret was rotated successfully
     */
    rotateWebhookSecret(id) {
        return __request(this.client, this.config, {
            method: 'PUT',
            url: '/webhooks/{id}/rotate-secret',
            path: {
                id: id,
            },
            errors: {
                401: `Unauthorized. The API Key is invalid or disabled.`,
                404: `The webhook does not exist`,
                429: `Rate limit exceeded`,
            },
        });
    }
}
//# sourceMappingURL=WebhooksService.js.map